// extracted by mini-css-extract-plugin
export default {"container":"style_container__eeGOT","tab_content":"style_tab_content__NvT8P"};